export const CONFIG = {
  "PROJECTNAME": "ecc",
  "COMPANYNAME": "ECC",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10098002",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgb(53,168,223)",
    "primary100": "#d6d7df",
    "light": "rgb(53,168,223)",
    "secondary": "rgb(53,168,223)",
    "dark": "rgb(53,168,223)",
    "siteColor3": "#fff",
    "menuSecondary": "rgb(53,168,223)"
  }
};